import { ArrowDown, ArrowUp, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SECTION_META, newSection } from "@/lib/library";
import { PersonalityEditor } from "@/pages/assessments/builder/PersonalityEditor";
import { ItemSection } from "@/pages/assessments/builder/ItemSection";


export function SectionsStep({ t, set, canEdit, templateId, data, autosave }) {
  const sections = t.sections;
  const put = (i, s) => set({ sections: sections.map((x, j) => (j === i ? s : x)) });
  const move = (i, d) => { const n = [...sections]; [n[i], n[i + d]] = [n[i + d], n[i]]; set({ sections: n }); };
  const remove = (i) => set({ sections: sections.filter((_, j) => j !== i) });
  const add = (type) => set({ sections: [...sections, newSection(type)] });
  const has = (type) => sections.some((s) => s.type === type);
  return (
    <div className="space-y-4" data-testid="builder-sections">
      {data?.status === "published" && data?.active_invites > 0 && canEdit && <p className="rounded-[6px] border border-[#E8D7B0] bg-caution-tint px-4 py-2 text-sm" role="status" data-testid="version-notice">Changes will be saved as a new version; candidates already invited keep their version.</p>}
      {!sections.length && <p className="panel p-5 text-sm text-ink-muted">No sections yet. Add one below.</p>}
      {sections.map((s, i) => {
        const M = SECTION_META[s.type];
        return (
          <section key={s.id} className="panel space-y-4 p-5" data-testid={`section-${s.type}-${i}`}>
            <div className="flex flex-wrap items-center gap-2">
              <M.icon size={18} className="text-primary" aria-hidden />
              <Input value={s.title} disabled={!canEdit} onChange={(e) => put(i, { ...s, title: e.target.value })} className="h-9 max-w-sm font-medium" aria-label="Section title" data-testid={`section-title-${i}`} />
              <span className="text-xs text-ink-muted">{M.label}</span>
              {canEdit && <span className="ml-auto flex gap-1">
                <Button size="icon" variant="ghost" disabled={i === 0} onClick={() => move(i, -1)} aria-label="Move section up" data-testid={`section-up-${i}`}><ArrowUp size={15} /></Button>
                <Button size="icon" variant="ghost" disabled={i === sections.length - 1} onClick={() => move(i, 1)} aria-label="Move section down" data-testid={`section-down-${i}`}><ArrowDown size={15} /></Button>
                <Button size="icon" variant="ghost" onClick={() => remove(i)} aria-label="Remove section" data-testid={`section-remove-${i}`}><Trash2 size={15} /></Button>
              </span>}
            </div>
            <p className="text-xs text-ink-muted">{M.hint}</p>
            {s.type === "personality" && <PersonalityEditor s={s} onChange={(x) => put(i, x)} canEdit={canEdit} />}
            {s.type !== "personality" && <ItemSection s={s} onChange={(x) => put(i, x)} canEdit={canEdit} templateId={templateId} jobId={data?.job_id} autosave={autosave} />}
          </section>
        );
      })}
      {canEdit && (
        <div className="panel flex flex-wrap items-center gap-2 border-dashed p-4" data-testid="add-section-bar">
          <span className="mr-2 text-sm font-medium">Add a section</span>
          {Object.entries(SECTION_META).map(([type, M]) => (
            <Button key={type} size="sm" variant="outline" disabled={["personality", "scenarios"].includes(type) && has(type)} onClick={() => add(type)} data-testid={`add-section-${type}`}>
              <Plus size={14} /> {M.label}</Button>
          ))}
        </div>
      )}
    </div>
  );
}
